import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "..";

const selectFooter = (state: RootState) => state.cmsBlock.footer;
const selectHelpUsGrow = (state: RootState) => state.cmsBlock.helpusGrow;
const selectContactSales = (state: RootState) => state.cmsBlock.contactSlaes;
const selectContactUs = (state: RootState) => state.cmsBlock.contactUs;
const selectTermsAndConditions = (state: RootState) =>
  state.cmsBlock.termsAndConditions;

export const selectFooterSelector = createSelector(
  selectFooter,
  (cmsBlock) => cmsBlock
);
export const selectHelpUsGrowSelector = createSelector(
  selectHelpUsGrow,
  (cmsBlock) => cmsBlock
);
export const selectContactSalesSelector = createSelector(
  selectContactSales,
  (cmsBlock) => cmsBlock
);
export const selectContactUsSelector = createSelector(
  selectContactUs,
  (cmsBlock) => cmsBlock
);
export const selectTermsAndConditionsSelector = createSelector(
  selectTermsAndConditions,
  (cmsPage) => cmsPage
);
